const ACTION_NAME = 'add-to-home-screen'
const BANNER_NAME = `${ACTION_NAME}-banner`
const POPUP_NAME = `${ACTION_NAME}-popup`
const CLOSE_BANNER_ACTION_NAME = `close-${BANNER_NAME}`
const CLOSE_POPUP_ACTION_NAME = `close-${POPUP_NAME}`

export {ACTION_NAME, CLOSE_BANNER_ACTION_NAME, CLOSE_POPUP_ACTION_NAME}
